import Vue from "vue";
import Vuex from "vuex";

const strict = process.env.NODE_ENV !== "production";
Vue.use(Vuex);

const requireModule = require.context("./modules", false, /\w+\.js$/);
const modules = {};

requireModule.keys().forEach(fileName => {
  const config = requireModule(fileName);
  const name = fileName
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");
  const options = config.default || config;

  modules[name] = options;
});

const getters = {
  routeParams(state, getters, rootState) {
    let { tournament_id, match_id } = rootState.route.params;
    return {
      tournament_id: +tournament_id || null,
      match_id: +match_id || null
    };
  },

  partners: () => [
    // {
    //   name: "Gamer Stadium",
    //   link: "https://gamerstadium.ru",
    //   logo: require("@/assets/img/partners/GamerStadium_logo.svg"),
    //   logo_footer: require("@/assets/img/partners/GamerStadium_logo_horizontal.svg")
    // },
    // {
    //   name: "HYPERPC",
    //   link: "https://hyperpc.ru/",
    //   logo: require("@/assets/img/partners/hyperpc-logo-wht.png"),
    //   logo_footer: require("@/assets/img/partners/hyperpc-logo-wht_horizontal.png")
    // },
    // {
    //   name: "Vega Squadron",
    //   link: "https://vk.com/vegasquadron/",
    //   logo: require("@/assets/img/partners/vegasquadron.svg"),
    //   logo_footer: require("@/assets/img/partners/vegasquadron.svg")
    // },
    // {
    //   name: "Loudplay",
    //   descr:
    //     "Комп не тянет современные игры?<br />Запусти игру в облаке по промокоду <span>Redbull</span>",
    //   link: "https://www.loudplay.ru/",
    //   logo: require("@/assets/img/partners/loudplay_logo.svg"),
    //   logo_footer: require("@/assets/img/partners/loudplay_logo_horizontal.svg")
    // },
    {
      name: "Cooler Master",
      link: "http://bit.ly/Cooler_Master_rr_g",
      logo: require("@/assets/img/partners/cooler-master.png"),
      logo_footer: require("@/assets/img/partners/cooler-master.png")
    },
    {
      name: "HYPERX",
      link: "https://bit.ly/hyperx_RR_G",
      logo: require("@/assets/img/partners/hyperx.svg"),
      logo_footer: require("@/assets/img/partners/hyperx.svg")
    },
    {
      name: "AOC",
      link: "http://bit.ly/AOC_rr_g",
      logo: require("@/assets/img/partners/aoc-big2.png"),
      logo_footer: require("@/assets/img/partners/aoc2.png")
    },
    {
      name: "HYPERPC",
      link: "http://bit.ly/hyperPC_rr_g",
      logo: require("@/assets/img/partners/hyperpc-logo-wht.png"),
      logo_footer: require("@/assets/img/partners/hyperpc-logo-wht_horizontal.png")
    }
  ]
};
const mutations = {};
const actions = {};

const store = new Vuex.Store({
  strict,
  getters,
  mutations,
  actions,
  modules
});

for (const moduleName of Object.keys(modules)) {
  if (modules[moduleName].actions.init) {
    store.dispatch(`${moduleName}/init`);
  }
}

export default store;
